module.exports = "//docs.gtimg.com/slide/img/_/node_modules/@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_stockchart_06l_66-8a70a4.svg";